<div class="filters-container scrolling-filters">

  <filter-by isNonvanguard="isNonVanguard"></filter-by>
  <c11n-accordion-group>
    <c11n-accordion *ngIf="!is529()" labelText="Product type" labelWeight="bold" isExpanded="true">
      <div accordion-body>
        <product-type-filter
          [showFilters]="showFilters"
          [initialPageLoad]="initialPageLoad"
          [accountingTypeOptions]="accountingTypeOptions">
      </product-type-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Strategies" *ngIf="!isNonVanguardMutualFunds()" labelWeight="bold">
      <div accordion-body><strategy-filter [productType]="productType"></strategy-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Management Style" *ngIf="!isNonVanguardMutualFunds()" labelWeight="bold">
      <div accordion-body><management-style-filter></management-style-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Asset Class" labelWeight="bold">
      <div accordion-body><asset-class-filter></asset-class-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Risk Scale" *ngIf="!isNonVanguardMutualFunds()" labelWeight="bold">
      <div accordion-body><risk-filter></risk-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Investment Minimum" *ngIf="!is529() && !isNonVanguardMutualFunds()" labelWeight="bold">
      <div accordion-body><investment-minimum-filter></investment-minimum-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Share Classes" *ngIf="!is529() && !isNonVanguardMutualFunds()" labelWeight="bold">
      <div accordion-body><share-class-filter></share-class-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Tax efficiency" *ngIf="!is529()" labelWeight="bold">
      <div accordion-body><tax-efficiency-filter></tax-efficiency-filter></div>
    </c11n-accordion>
    <c11n-accordion labelText="Region" labelWeight="bold">
      <div accordion-body><region-filter></region-filter></div>
    </c11n-accordion>
  </c11n-accordion-group>
</div>
